import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import '@mdi/font/css/materialdesignicons.css' 

loadFonts()

vuetify.icons = {
  iconfont: 'md', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
}

// axios.defaults.baseURL = configData.baseURL

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')